export const _getComponent = (data, tabs) => {
  const item = data.find((item) => item.label === tabs);
  return item ? item.view : null;
};
